@if (hasMoreThenOneElSg()) {
  <span><i>Open details to view</i></span>
} @else {
  <atn-ds-tag [text]="firstElValueSg()" />
}
